import { DatasetState } from "./active-dataset-state";
import { FeedbackState } from "./feedback-state";
import { TranslationState, i18nDefault } from "./translation-state";
import { TokenState } from "./token-state";
import { UserState } from "./user-state";
import { ChatItem } from "@nlux/react";
import { DisclaimerState } from "./disclaimer-state";

export interface AppState {
  feedback: FeedbackState | undefined;
  translation: TranslationState;
  activeDataset: DatasetState;
  postLoginRedirectUri: string | undefined;

  // auth data
  token: TokenState;
  user: UserState;

  conversationHistory: Array<ChatItem>;

  disclaimer: DisclaimerState;
}

export const initialState: AppState = {
  feedback: undefined,
  translation: {
    locale: "default",
    translations: i18nDefault,
  },
  activeDataset: {
    id: "",
    releaseId: "",
  },
  postLoginRedirectUri: undefined,
  token: {
    idToken: null,
    idTokenClaims: {
      sub: null,
      oid: null,
      name: null,
      username: null,
      email: null,
      exp: 0,
    },
  },
  user: {
    userId: null,
    idpUserId: null,
    canAccessSystemAdminPortal: false,
    canAccessResearcherPortal: false,
    canAccessEtlPortal: false,
    isResearcher: false,
    isUserAdmin: false,
    isSystemAdmin: false,
    isDashboardViewer: false,
    isDatasetResearcher: {},
  },
  conversationHistory: [],
  disclaimer: {
    shouldDisplay: undefined,
    isDisclaimerAccepted: false,
  },
};
